import { Component, OnInit } from '@angular/core';
import { AdministrationService } from 'src/app/services/administration/administration.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-notice-board',
  templateUrl: './notice-board.component.html',
  styleUrls: ['./notice-board.component.css']
})
export class NoticeBoardComponent implements OnInit {

  NoticeDetails:any;
  Submitted:boolean=false;
  SelectedFileForUpload:any;

  constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    NoticeBoardModel = {
      NoticeID: 0,
      NoticeHeading: '',
      Notice: '',
      NoticeDate: '',
      ApprovedBy: '',
      FilePath: '',
      IsActive: true
  };

  Clear = function () {
      this.NoticeBoardModel.NoticeID = 0;
      this.NoticeBoardModel.NoticeHeading = '';
      this.NoticeBoardModel.Notice = '';
      this.NoticeBoardModel.NoticeDate = '';
      this.NoticeBoardModel.ApprovedBy = '';
      this.NoticeBoardModel.IsActive = true;
      this.Submitted = false;
  };

 
 SaveNoticeBoard(valid) {
   
      this.Submitted = true;
      if (valid) {
        this.spinnerService.show();
        this.NoticeBoardModel.NoticeDate = this.NoticeBoardModel.NoticeDate != null && this.NoticeBoardModel.NoticeDate != '' ? moment(this.NoticeBoardModel.NoticeDate).format('DD-MMM-YYYY') : '';
          this.adminservice.SaveNoticeBoard(JSON.stringify(this.NoticeBoardModel), (this.SelectedFileForUpload)).subscribe((response: any) => {
            this.spinnerService.hide();
              if (response.webResponse.Status && this.NoticeBoardModel.NoticeID == 0) {
                  this.Clear();
              }
              this.GetAllNotice();
              this.globalHelper.CheckActionStatus(response);
          });
      }
  }

  selectFileforUpload(file) {
      this.SelectedFileForUpload = file[0];
  };


  GetAllNotice() {
    this.spinnerService.show();
      this.adminservice.GetAllNotice().subscribe((response: any) => {
          this.NoticeDetails = response.NoticeDetails;
          this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(response);
      });
  };

  Edit(obj) {
      this.NoticeBoardModel.NoticeID = obj.NoticeID;
      this.NoticeBoardModel.NoticeHeading = obj.NoticeHeading;
      this.NoticeBoardModel.Notice = obj.Notice;
      this.NoticeBoardModel.NoticeDate = obj.NoticeDate!=null?moment(obj.PublishDate).format('DD-MMM-YYYY'):'';
      this.NoticeBoardModel.ApprovedBy = obj.ApprovedBy;
      this.NoticeBoardModel.FilePath = obj.FilePath;
      this.NoticeBoardModel.IsActive = obj.IsActive;
  };

  NoticeMarkActive(item) {
      this.NoticeBoardModel.NoticeID = item.NoticeID;
      this.NoticeBoardModel.IsActive = item.IsActive == true ? false : true;
      this.adminservice.NoticeMarkActive(JSON.stringify(this.NoticeBoardModel)).subscribe((response: any) => {
          this.GetAllNotice();
          this.globalHelper.CheckActionStatus(response);

      });
  }

  ngOnInit() {
    this.GetAllNotice();

  }

}
